<template>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-8 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
    <div class="cert-article">
      <h3 class="mb-4">Cyber Incident Reporting</h3>
      <p>
        Cyber incidents are events that threaten the confidentiality, integrity, or availability of digital
        information
        or information systems. Unreported cyber incidents can result in significant damage to the affected party.
        Accordingly, victims are encouraged to report to Rwanda-Computer Emergency Response Team (Rw-CERT)
        all cyber incidents that may:
      </p>
      <ul>
        <li>result in a significant loss of data, system unavailability (denial of service), or un authorized
          control of systems;
        </li>
        <li>impact a large number of victims;</li>
        <li>indicate unauthorized access to, or malicious software present on critical information
          technology systems;
        </li>
        <li>affect critical infrastructure or core government functions;</li>
        <li>have impact national security, economic security, or public health and safety or result in organizational financial loss and reputational damage.</li>
      </ul>
      <p>
        All users are encouraged to immediately report to the Rwanda-Computer Emergency Response
        Team (Rw-CERT), any suspicious online activity or cyber incident for fast and appropriate action and
        advice. By reporting such computer security incidents to Rw-CERT, the system administrators and users
        will receive technical assistance on how to resolve such incidents.
        This also helps the Rw-CERT to correlate accurately the incidents reported and analyze them; draw
        inferences; disseminate up-to-date information; and develop effective security guidelines to prevent the
        occurrence of such or similar incidents in the future.
      </p>

      <h4 class="mt-5 mb-4">What can I report to Rw-CERT?</h4>
      <p>Cyber incidents that may be reported include:</p>
      <ul>
        <li>phishing (users receiving suspicious emails)</li>
        <li>hacking (such as unauthorized access to one’s own device)</li>
        <li>denial of service</li>
        <li>malware and viruses</li>
        <li>ransomware (encrypted files or devices)</li>
        <li>website defacement</li>
        <li>spamming</li>
        <li>unauthorized access to computer systems</li>
        <li>compromised email accounts</li>
        <li>sextortion</li>
        <li>user identity theft</li>
        <li>attacks on computer systems and any other cyber security related incidents</li>
      </ul>

      <h4 class="mt-5 mb-4">How to report an incident to Rw-CERT</h4>
      <p>
        Cyber security incidents can be reported via
        <router-link :to="{path: '/report-incident'}">Rw-CERT website</router-link>
        through the online reporting form as well as at Rw-CERT’s office.
        Incidents should not be reported from a machine which you think is infected.
        For proof of identity, the incident reporting party should bring their Identity Card.
        In case the individual with a report cannot report the incident personally, then he/she can authorize
        another person to report on their behalf, with an authorization letter duly signed, and ID card or power
        of attorney. The incident reporting party should preserve all the available information without any
        alteration.
        Enquiries about incidents can be made through Rw-CERT Hotline: <strong>9009 or 0781813310</strong> or by email at
        <strong>incident@ncsa.gov.rw</strong>.
      </p>

      <h4 class="mt-5 mb-4">What follows after reporting the incident?</h4>
      <p>
        After reporting the incident, the incident reporting party will immediately (as soon as the incident is
        received) receive an acknowledgment email.
        The reporting party will be informed when the incident is resolved or if any other information or
        clarification is required.
      </p>

      <h4 class="mt-5 mb-4">What should not be reported to Rw-CERT?</h4>
      <p>
        The following IT issues should <strong>NOT</strong> be reported to Rw-CERT:
      </p>
      <ul>
        <li>Forgotten passwords or blocked/locked accounts by systems or system admins</li>
        <li>VOIP services not working correctly (e.g. Zoom)</li>
        <li>Hardware problems</li>
        <li>Network connection problems (e.g. limited/exhausted bandwidth, slowness, etc.)</li>
        <li>Printer issues</li>
        <li>Any other non-cyber security-related issue(s)</li>
      </ul>
      <p>
        For actions that require legal intervention and investigation, the reporting party should contact Rwanda
        Investigation Bureau (RIB), <a href="//www.rib.gov.rw/index.php?id=293">Cybercrime unit </a>
      </p>

    </div>
  </div>
</template>

<script>
export default {
  name: "GuideIncident"
}
</script>
